import { routes } from "./const";
import { ENavGroups, ERoutes, IRoute } from "./types";

const getRoute = (id: ERoutes): IRoute | undefined => {
	return routes.find(route => route.id === id)
}

const getRoutes = (parentId: ERoutes): IRoute[] => {
	return routes.filter(route => route.id === parentId)
}

const getRoutesByGroupId = (groupId: ENavGroups): IRoute[] => {
	return routes.filter(
		r => r.nav && r.nav.groupId === groupId
	)
}

export {
	getRoute,
	getRoutes,
	getRoutesByGroupId
}